import React from "react";
import "./PrivacyPolicy.css";

function PrivacyPolicy() {
  return (
    <div className="content-grid my-6" style={{ color: "#344563" }}>
      <section className="mb-6">
        <h1 className="title text-4xl font-bold">POLITICA SULLA PRIVACY</h1>
        <p className="text-sm">
          Extraconomy si impegna a rispettare la privacy e la sicurezza dei dati personali di tutti
          i nostri clienti e visitatori. La presente Politica sulla Privacy descrive come
          raccogliamo, utilizziamo, memorizziamo e proteggiamo le informazioni fornite dagli utenti
          sul nostro sito e/o sulle relative applicazioni.
        </p>
        <p className="text-sm">
          Vi consigliamo di leggere attentamente questo documento per comprendere le nostre
          procedure di trattamento dei dati. In caso di dubbi, contattateci attraverso i canali
          indicati al termine di questa Politica sulla Privacy.
        </p>
      </section>
      <section className="mb-6">
        <h1 className="title font-bold text-xl">1. RACCOLTA DEI DATI</h1>
        <p className="font-bold">1.1 Informazioni fornite direttamente dall’utente</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              Dati di registrazione: Quando create un account o effettuate un acquisto con noi,
              potremmo richiedere il vostro nome, e-mail, indirizzo, numero di telefono, codice
              fiscale (quando applicabile) e altre informazioni necessarie per completare la
              registrazione.
            </p>
          </li>
          <li>
            <p className="">
              Informazioni di pagamento: Per effettuare i pagamenti, raccogliamo dati come le
              informazioni sulla carta di credito, il metodo di pagamento, l’indirizzo di
              fatturazione e altri dati necessari per elaborare transazioni in sicurezza.
            </p>
          </li>
          <li>
            <p className="">
              Comunicazioni: Quando entrate in contatto con Extraconomy (tramite e-mail, modulo di
              contatto, chat o telefono), possiamo raccogliere le informazioni fornite a fini di
              registrazione e per risolvere le richieste.
            </p>
          </li>
        </ul>
        <p className="font-bold">1.2 Informazioni raccolte automaticamente</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              Dati di navigazione: Possiamo raccogliere informazioni come l’indirizzo IP, il tipo di
              browser, le pagine visitate, il tempo di permanenza sul sito, le date e gli orari di
              accesso, nonché dati di geolocalizzazione (se abilitati).
            </p>
          </li>
          <li>
            <p className="">
              Cookie e tecnologie simili: Utilizziamo cookie e tecnologie di tracciamento per
              migliorare l’esperienza dell’utente, memorizzare le preferenze, comprendere l’uso del
              sito e offrire contenuti personalizzati. È possibile configurare il browser per
              rifiutare i cookie, ma ciò potrebbe influire su alcune funzionalità del sito.
            </p>
          </li>
        </ul>
      </section>
      <section className="mb-6">
        <h1 className="title font-bold text-xl">2. UTILIZZO DELLE INFORMAZIONI</h1>
        <p className="font-bold">2.1 Fornitura di servizi e funzionalità</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              Utilizziamo i dati raccolti per rendere possibile il nostro servizio, elaborare gli
              acquisti, effettuare le consegne, offrire assistenza clienti e adempiere ai nostri
              obblighi contrattuali.
            </p>
          </li>
        </ul>
        <p className="font-bold">2.2 Comunicazione con l’utente</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              Potremmo utilizzare le vostre informazioni di contatto per inviare notifiche
              riguardanti i vostri ordini, aggiornamenti sulle nostre politiche, nonché per
              informarvi su promozioni, prodotti, servizi e altri contenuti che potrebbero
              interessarvi. Qualora non desideriate più ricevere nostre comunicazioni, potete
              richiederne la cancellazione in qualsiasi momento.
            </p>
          </li>
        </ul>
        <p className="font-bold">2.3 Miglioramento e personalizzazione dell’esperienza</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              Analizziamo i dati di utilizzo e i feedback per comprendere meglio le preferenze e i
              comportamenti degli utenti, migliorare le funzionalità del sito e personalizzare
              contenuti e offerte.
            </p>
          </li>
        </ul>
        <p className="font-bold">2.4 Conformità agli obblighi di legge</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              Potremmo utilizzare e condividere i dati per adempiere a obblighi di legge, normativi
              o per rispondere alle richieste delle autorità competenti, nei termini della
              legislazione applicabile.
            </p>
          </li>
        </ul>
      </section>
      <section className="mb-6">
        <h1 className="title font-bold text-xl">3. CONDIVISIONE DEI DATI</h1>
        <p className="font-bold">3.1 Fornitori di servizi</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              Potremmo condividere le vostre informazioni con terze parti incaricate di svolgere
              funzioni per nostro conto (ad esempio, elaborazione dei pagamenti, logistica di
              consegna, hosting di database). Questi partner ricevono solo i dati strettamente
              necessari per fornire i loro servizi e devono utilizzarli esclusivamente secondo le
              nostre istruzioni, mantenendoli protetti.
            </p>
          </li>
        </ul>
        <p className="font-bold">3.2 Autorità e obblighi di legge</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              Potremmo condividere dati personali per soddisfare requisiti legali, ordini giudiziari
              o quando riteniamo in buona fede che tale divulgazione sia necessaria per tutelare i
              nostri diritti, la sicurezza degli utenti o di terzi.
            </p>
          </li>
        </ul>
        <p className="font-bold">3.3 Trasferimenti di attività aziendali</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              Qualora Extraconomy fosse soggetta a fusioni, acquisizioni o cessioni di asset, i dati
              degli utenti potrebbero essere trasferiti, nel rispetto della continuità della
              presente Politica sulla Privacy.
            </p>
          </li>
        </ul>
      </section>
      <section className="mb-6">
        <h1 className="title font-bold text-xl">4. CONSERVAZIONE E SICUREZZA DEI DATI</h1>
        <p className="font-bold">4.1 Conservazione</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              I dati raccolti sono memorizzati su server sicuri e/o su servizi cloud, ubicati in
              Brasile o all'estero, sempre in conformità con la normativa applicabile in materia di
              privacy e protezione dei dati.
            </p>
          </li>
        </ul>
        <p className="font-bold">4.2 Misure di sicurezza</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              Adottiamo misure tecniche e organizzative adeguate per proteggere le informazioni da
              accessi non autorizzati, distruzione, perdita, alterazione o qualsiasi forma di
              trattamento illecito o inappropriato. Tra queste misure rientrano l'utilizzo di
              protocolli di crittografia (SSL), il controllo degli accessi e il monitoraggio
              regolare di eventuali vulnerabilità.
            </p>
          </li>
        </ul>
        <p className="font-bold">4.3 Tempi di conservazione</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              Conserveremo i vostri dati personali solo per il tempo necessario a conseguire le
              finalità per cui sono stati raccolti o per soddisfare obblighi legali e normativi. Al
              termine di tale periodo, i dati verranno eliminati o resi anonimi in modo sicuro.
            </p>
          </li>
        </ul>
      </section>
      <section className="mb-6">
        <h1 className="title font-bold text-xl">5. DIRITTI DEGLI INTERESSATI</h1>
        <p className="font-bold">5.1 Accesso e rettifica</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              Potete richiedere l'accesso ai vostri dati personali e, se necessario, chiederne la
              rettifica se ritenete che siano imprecisi o incompleti.
            </p>
          </li>
        </ul>
        <p className="font-bold">5.2 Cancellazione e opposizione</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              Potete richiedere la cancellazione dei vostri dati qualora riteniate che Extraconomy
              li stia trattando in modo superfluo o in violazione della legge. È inoltre possibile
              opporsi al trattamento dei dati per determinate finalità.
            </p>
          </li>
        </ul>
        <p className="font-bold">5.3 Portabilità</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              Quando applicabile, avete il diritto di richiedere la portabilità dei vostri dati a un
              altro fornitore di servizi o prodotti.
            </p>
          </li>
        </ul>
        <p className="font-bold">5.4 Revoca del consenso</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              Quando il trattamento dei dati personali si basa sul consenso, potete revocarlo in
              qualsiasi momento, senza che ciò pregiudichi la liceità del trattamento effettuato in
              precedenza.
            </p>
          </li>
        </ul>
        <p className="">
          Per esercitare i vostri diritti, contattateci attraverso i canali indicati al termine di
          questa Politica.
        </p>
      </section>
      <section className="mb-6">
        <h1 className="title font-bold text-xl">6. COOKIE E TECNOLOGIE DI TRACCIAMENTO</h1>
        <p className="font-bold">6.1 Che cosa sono i cookie?</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              I cookie sono piccoli file di testo inviati al vostro browser dai siti che visitate.
              Aiutano il sito a ricordare le informazioni sulla vostra visita, come le preferenze
              linguistiche e altre impostazioni, per migliorare la vostra esperienza.
            </p>
          </li>
        </ul>
        <p className="font-bold">6.2 Come utilizziamo i cookie</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              Cookie strettamente necessari: Essenziali per il corretto funzionamento del sito (ad
              es. navigazione, accesso ad aree protette del sito).
            </p>
          </li>
          <li>
            <p className="">
              Cookie di analisi e prestazione: Raccolgono informazioni anonime su come gli utenti
              utilizzano il sito, a fini statistici e di miglioramento dei servizi.
            </p>
          </li>
          <li>
            <p className="">
              Cookie di funzionalità: Ricordano le preferenze degli utenti per offrire un'esperienza
              più personalizzata.
            </p>
          </li>
          <li>
            <p className="">
              Cookie pubblicitari: Utilizzati per mostrare annunci pertinenti in base al vostro
              profilo di navigazione.
            </p>
          </li>
        </ul>
        <p className="font-bold">6.3 Gestione dei cookie</p>
        <ul className="list-spacing">
          <li>
            <p className="">
              Potete gestire o disattivare i cookie nelle impostazioni del vostro browser. Tuttavia,
              la disattivazione di alcuni cookie potrebbe influire sulla funzionalità del sito.
            </p>
          </li>
        </ul>
      </section>
      <section className="mb-6">
        <h1 className="title font-bold text-xl">7. TRASFERIMENTO INTERNAZIONALE DEI DATI</h1>
        <ul className="list-spacing">
          <li>
            <p className="">
              Extraconomy potrebbe trasferire alcuni dati a fornitori o partner situati in altri
              paesi. In tal caso, adotteremo misure per garantire che tali dati ricevano una
              protezione adeguata, come previsto dalla normativa applicabile.
            </p>
          </li>
        </ul>
      </section>
      <section className="mb-6">
        <h1 className="title font-bold text-xl">8. SERVIZI DI TERZI</h1>
        <ul className="list-spacing">
          <li>
            <p className="">
              Il nostro sito potrebbe contenere link a siti di terze parti o utilizzare servizi
              esterni che possono raccogliere le vostre informazioni. Non siamo responsabili delle
              pratiche sulla privacy di tali terze parti. Vi consigliamo di leggere le politiche
              sulla privacy di ogni servizio e/o sito che visitate.
            </p>
          </li>
        </ul>
      </section>
      <section className="mb-6">
        <h1 className="title font-bold text-xl">9. AGGIORNAMENTI DELLA POLITICA SULLA PRIVACY</h1>
        <ul className="list-spacing">
          <li>
            <p className="">
              Extraconomy si riserva il diritto di modificare la presente Politica sulla Privacy in
              qualsiasi momento. La versione aggiornata sarà sempre disponibile sul nostro sito. In
              caso di modifiche rilevanti, sarete avvisati tramite e-mail o altro mezzo di
              comunicazione disponibile.
            </p>
          </li>
        </ul>
      </section>
      <section className="mb-6">
        <h1 className="title font-bold text-xl">10. FALE CONOSCO</h1>
        <ul className="list-spacing">
          <li>
            <p className="">
              Se avete domande, commenti o richieste riguardanti la presente Politica sulla Privacy
              o il trattamento dei vostri dati personali da parte di Extraconomy, contattateci
              attraverso i seguenti canali:
            </p>
          </li>
        </ul>
        <p className="">E-mail: contato-politicas@extraconomy.com</p>
        <p className="">Telefone/WhatsApp: +35 908-98374-888</p>
        <p className="">Endereço: Via Nomentana, 1018 - 00137 Roma (IT)</p>
        <p className="">
          Vi ringraziamo per aver scelto Extraconomy. Restiamo a disposizione per qualsiasi
          chiarimento e per garantire la massima trasparenza sul modo in cui trattiamo i vostri dati
          personali.
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
